import { useMediaQueryBreakpoint } from "@hooks";

interface LinearGradientProps {
  id: string;
  gradientStart: number;
  gradientEnd: number;
  baseColor: string;
}

export const LinearGradient = ({
  id,
  gradientStart,
  gradientEnd,
  baseColor,
}: LinearGradientProps) => {
  const { isDesktop, isDesktopXl } = useMediaQueryBreakpoint();
  const scale = isDesktopXl ? 1 : isDesktop ? 0.715 : 1;
  const totalHeight = 1572 * scale;

  const getOffset = (index: number) => {
    const start = gradientStart / totalHeight;
    const end = gradientEnd / totalHeight;
    return start + index * (end - start);
  };

  return (
    <linearGradient id={id} x1="0%" y1="0%" x2="0%" y2={1}>
      <stop offset={getOffset(0) - 0.0025} stopColor={`${baseColor}00`} />
      <stop offset={getOffset(0)} stopColor={baseColor} />
      <stop offset={getOffset(0.075)} stopColor="#96c5f0" />
      <stop offset={getOffset(0.25)} stopColor="#05df54" />
      <stop offset={getOffset(0.875)} stopColor="#96c5f0" />
      <stop offset={getOffset(1)} stopColor={baseColor} />
      <stop offset={getOffset(1) + 0.0025} stopColor={`${baseColor}00`} />
    </linearGradient>
  );
};
